import React from 'react';
import ReactMultiSelect from '../helper/reactMultiSelect';
import clone from 'clone';
import Select from 'react-select';

class PreQueryPanel extends React.Component {
  constructor(props) {
    super(props);
    this.handleTaxonomy = this.handleTaxonomy.bind(this);
    this.handleSelectValue = this.handleSelectValue.bind(this);
    this.state = {
      optionsForOthers: [{
        value: 'popular-asc',
        label: 'popular-asc',
      }, {
        value: 'popular-dsc',
        label: 'popular-dsc',
      }, {
        value: 'date-asc',
        label: 'date-asc',
      }, {
        value: 'date-dsc',
        label: 'date-dsc',
      }, {
        value: 'title-asc',
        label: 'title-asc',
      }, {
        value: 'title-dsc',
        label: 'title-dsc',
      }],
    };
  }
  componentWillMount() {
    const taxonomies = [];
    if (this.props.helperData === undefined) {
      return;
    }
    if (this.props.helperData.hasOwnProperty('terms')) {
      const terms = clone(this.props.helperData.terms);
      for (const key in terms) {
        if (terms.hasOwnProperty(key)) {
          for (let index = 0; index < terms[key].linear.length; index++) {
            const temp = {};
            temp.value = terms[key]['linear'][index].slug;
            temp.label = terms[key]['linear'][index].slug;
            taxonomies.push(temp);
          }
        }
      }
    }
    this.setState({ taxonomies });
  }
  handleTaxonomy(value) {
    this.props.handleTaxonomySelection(value);
  }
  handleSelectValue(val) {
    if (val === null) {
      this.props.selectPrequery('');
    } else {
      this.props.selectPrequery(val.value);
    }
  }
  render() {
    return (<div className="grid-choose-option">
      <ReactMultiSelect options={this.state.taxonomies} handleOperation={this.handleTaxonomy}
        values={this.props.defaultTaxonomy}
      />

      <Select options={this.state.optionsForOthers} value={this.props.defaultPrequery}
        onChange={this.handleSelectValue}
      />
    </div>);
  }
}

PreQueryPanel.propTypes = {
  'handleTaxonomySelection': React.PropTypes.func,
  'handleMetaSelection': React.PropTypes.func,
  'defaultTaxonomy': React.PropTypes.array,
  'defaultMeta': React.PropTypes.array,
  'helperData': React.PropTypes.object,
  'defaultPrequery': React.PropTypes.string
};

export default PreQueryPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/prequery.js